import { RumInitConfiguration } from "@datadog/browser-rum";

export class DatadogResolver {
  static resolveConfig(
    environment: string,
    version: string | undefined
  ): RumInitConfiguration {
    const sbxEnvironments = ["dev", "local"];
    const useSbx =
      sbxEnvironments.includes(environment) ||
      (process.env["NODE_ENV"] === "development" &&
        process.env["REACT_APP_BUILD_NUMBER"] === "local");

    const env = useSbx ? "dev" : environment;

    const applicationId = useSbx ? "b11beb4f-5e13-4c2b-a8a1-253395965bea" : "b46b8fa7-439d-48e6-b316-885997f8b918";
    const clientToken = useSbx ? "pub3ee671a795a7f83779979cf4f8c5a958" : "pubff323c45350ee170592f8b0504683b13";

    return {
      applicationId: applicationId,
      clientToken: clientToken,
      site: "datadoghq.com",
      service: "drplocatorspa",
      env: env,
      version: version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    };
  }
}
